<template>
  <div v-show="visible" class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">渲染趋势</h2>
    </div>

    <div class="part__cnt">
      <div v-if="labelsHasData" class="label_style mt-3">
        <ul>
          <li>Max(Drawcall)[次]</li>
          <li>{{ testInfo?.max_dc }}</li>
        </ul>
        <ul>
          <li>Avg(Drawcall)[次]</li>
          <li>{{ testInfo?.avg_dc }}</li>
        </ul>
        <ul>
          <li>Max(三角形)[个]</li>
          <li>{{ testInfo?.max_triangle }}</li>
        </ul>
      </div>

      <div v-show="hasData(draw_callDataFields)" class="position-relative mt-3">
        <div
          id="draw_call_line"
          style="width: 100%; height: 400px"
        ></div>
        <div id="draw_call_line_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="draw_call_line_chart" />
        <chart-rect ref="chartRect1" chartKey="draw_call_line_chart" />
      </div>

      <div v-show="hasData(triangleDataFields)" class="position-relative mt-3">
        <div
          id="triangle_line"
          style="width: 100%; height: 400px"
        ></div>
        <div id="triangle_line_tip" class="position-absolute bg-white shadow rounded p-2" style="display: none"></div>
        <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="triangle_line_chart" />
        <chart-rect ref="chartRect2" chartKey="triangle_line_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

const useDraw_call = {
  data() {
    return {
      draw_callSeries: [
        {name: 'drawcall', dataKey: 'DrawCall'},
      ]
    }
  },

  computed: {
    draw_callDataFields() {
      return this.draw_callSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getDraw_callOption() {
      return {
        title: {
          text: "DrawCall",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        tooltip: this.chartSettings.tooltip,
        toolbox: this.chartSettings.toolbox,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.draw_callSeries.map(item => {
          return {
            name: item.name,
            data: this.secondData?.[item.dataKey],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
          }
        })
      }
    },

    drawPieChartDrawCall() {
      let chartDom = document.getElementById("draw_call_line")
      if (!chartDom) return
      if (!allChart.draw_call_line_chart) {
        allChart.draw_call_line_chart = echarts.init(chartDom)
      }
      allChart.draw_call_line_chart.setOption(this.getDraw_callOption(), {notMerge: true})
    },
  }
}

const useTriangle = {
  data() {
    return {
      triangleSeries: [
        {name: 'triangle', dataKey: 'Triangle'},
      ]
    }
  },

  computed: {
    triangleDataFields() {
      return this.triangleSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getTriangleOption() {
      return {
        title: {
          text: "三角形数量",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: [
          {
            name: "triangle",
            type: "line",
            showSymbol: false,
            data: this.secondData?.Triangle,
            itemStyle: this.chartSettings.itemStyle2,
          },
        ],
      }
    },

    drawPieChartTriangle() {
      let chartDom = document.getElementById("triangle_line")
      if (!chartDom) return
      if (!allChart.triangle_line_chart) {
        allChart.triangle_line_chart = echarts.init(chartDom)
      }
      allChart.triangle_line_chart.setOption(this.getTriangleOption(), {notMerge: true})
    },
  }
}

export default {
  mixins: [useDraw_call, useTriangle],

  inject: ['injectObj', 'hasData'],

  components: {LabelList, ChartRect},

  props: {
    testInfo: Object,
    chartSettings: Object,
    perf_second_data: Object,
  },

  data() {
    return {
      
    }
  },

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    project() {
      return this.$route.query.project
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    labelsHasData() {
      return this.isNotEmpty(this.testInfo?.max_dc) || this.isNotEmpty(this.testInfo?.avg_dc) || this.isNotEmpty(this.testInfo?.max_triangle)
    },

    visible() {
      return this.labelsHasData || this.hasData(this.draw_callDataFields) || this.hasData(this.triangleDataFields)
    },
  },

  methods: {
    isNotEmpty(val) {
      return val && val !== '-'
    },

    drawCharts() {
      this.drawPieChartDrawCall()
      this.drawPieChartTriangle()
    },

    async init(isMounted) {
      this.drawCharts()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      this.$refs.chartRect2?.init(isMounted)
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>